<script lang="ts">
  import { defineFilter } from '../../utils/global-search-utils'
  import { createContext } from 'reka-ui'

  export interface SearchFilterContext<
    T extends Record<string, ReturnType<typeof defineFilter>>
  > {
    searchFilters: T
  }

  const [_useSearchFilter, provideSearchFilter] = createContext<
    SearchFilterContext<any>
  >('gs-search-filter-context')

  export function useSearchFilter<
    T extends Record<string, ReturnType<typeof defineFilter>>
  >() {
    return _useSearchFilter() as SearchFilterContext<T>
  }
</script>

<script
  setup
  lang="ts"
  generic="T extends Record<string, ReturnType<typeof defineFilter>>"
>
  const props = defineProps<{
    searchFilters: T
  }>()

  provideSearchFilter({
    searchFilters: props.searchFilters
  })
</script>
<template>
  <slot />
</template>
